import TrimbleMaps from "@trimblemaps/trimblemaps-js";

const constants = {
  CONTROL_POSITION: {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
  },
  MapStyles: {
    NORMAL: "normal",
    HYBRID: "hybrid",
    SATELLITE: "satellite",
  },
  DRAWINGTYPES: {
    POLYLINE: "polyline",
    RECTANGLE: "rectangle",
    POLYGON: "polygon",
  },
  MARKER: {
    defaults: {
      anchor: {
        x: 11,
        y: 46,
      },
    },
  },
  EVENT: {
    SET_MAP_DRAW: "setMapDraw",
    CLEAR_MAP_DRAW: "clearMapDraw",
  },
  GEOMETRY_TYPE: {
    LINE_STRING: "LineString",
  },
  truckProfile: {
    costing: "truck",
    costing_options: {
      height: "4.118",
      width: "2.6",
      length: "20.73",
      weight: "39.19",
      axle_load: "15.42",
      hazmat: true,
    },
    units: "mi",
  },
  regions: {
    US: TrimbleMaps.Common.Region.NA,
  },
  DRAWING_EVENTS: {
    CREATE: "draw.create",
    UPDATE: "draw.update",
    DELETE: "draw.delete",
    SELECTION_CHANGE: "draw.selectionchange",
  },
};

export default constants;
